import { axiosInstance } from '../Axios';
import { toggleLoginScreen, storeData } from './UiReducer';

const { createSlice } = require('@reduxjs/toolkit');

const UserReducer = createSlice({
	name: 'user',
	initialState: {
		success: false,
		error: null,
		loadinguser: false,
		agentlogin: sessionStorage.getItem('agentlogin')
			? JSON.parse(sessionStorage.getItem('agentlogin'))
			: null,
		bookinghistoryagent: sessionStorage.getItem('bookinghistoryagent')
			? JSON.parse(sessionStorage.getItem('bookinghistoryagent'))
			: null,
		transagent: null,
		agentwallet: null,
		changepassword: null,
	},
	reducers: {
		agentloginRequest(state, action) {
			state.loadinguser = true;
		},
		agentloginSuccess(state, action) {
			state.loadinguser = false;
			state.agentlogin = action.payload;
			storeData('agentlogin', action.payload);
			state.error = null;
		},
		agentloginFail(state, action) {
			state.loadinguser = false;
			state.error = action.payload;
		},
		agentbookinghistoryRequest(state, action) {
			state.loadinguser = true;
		},
		agentbookinghistorySuccess(state, action) {
			state.loadinguser = false;
			state.bookinghistoryagent = action.payload;
			state.error = null;
		},
		agentbookinghistoryFail(state, action) {
			state.loadinguser = false;
			state.error = action.payload;
		},
		agenttransRequest(state, action) {
			state.loadinguser = true;
		},
		agenttransSuccess(state, action) {
			state.loadinguser = false;
			state.transagent = action.payload;
			state.error = null;
		},
		agenttransFail(state, action) {
			state.loadinguser = false;
			state.error = action.payload;
		},
		walletagentRequest(state, action) {
			state.loadinguser = true;
		},
		walletagentSuccess(state, action) {
			state.loadinguser = false;
			state.agentwallet = action.payload;
			state.error = null;
		},
		walletagentFail(state, action) {
			state.loadinguser = false;
			state.error = action.payload;
		},
		agentchangepasswordRequest(state, action) {
			state.loadinguser = true;
		},
		agentchangepasswordSuccess(state, action) {
			state.loadinguser = false;
			state.changepassword = action.payload;
			state.error = null;
		},
		agentchangepasswordFail(state, action) {
			state.loadinguser = false;
			state.error = action.payload;
		},
	},
});

const { actions } = UserReducer;
const config = {
	headers: {
		'Content-Type': 'application/json',
		'Client-Service': 'srk-client',
		'Auth-Key': 'srkapi',
		'Api-Key': 'NjO7hqe3PG9musafi==',
	},
};

export const {
	agentloginRequest,
	agentloginSuccess,
	agentloginFail,
	agentbookinghistoryRequest,
	agentbookinghistorySuccess,
	agentbookinghistoryFail,
	agenttransRequest,
	agenttransSuccess,
	agenttransFail,
	walletagentRequest,
	walletagentSuccess,
	walletagentFail,
	agentchangepasswordRequest,
	agentchangepasswordSuccess,
	agentchangepasswordFail,
} = actions;

export const agentloginDispatch =
	(bodyData, notify, errorF) => async (dispatch) => {
		try {
			dispatch(agentloginRequest());
			dispatch(toggleLoginScreen(false));

			const { data } = await axiosInstance.post(
				'agent/login',
				bodyData,
				config
			);
			dispatch(agentloginSuccess(data));
			if (data.status === 200) {
				notify();
				dispatch(
					agentbookinghistoryDispatch(
						data && data.result && data.result.result && data.result.result.id
					)
				);
				dispatch(
					agenttransactionhistoryDispatch(
						data && data.result && data.result.result && data.result.result.id
					)
				);
				dispatch(
					walletBalanceAgentDispatch(
						data &&
							data.result &&
							data.result.result &&
							data.result.result.email,
						data && data.result && data.result.result && data.result.result.id
					)
				);
			} else {
				errorF();
			}
		} catch (error) {
			errorF();
			dispatch(
				agentloginFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};
// export const agentlogoDispatch =
// 	(bodyData, id, history) => async (dispatch) => {
// 		try {
// 			dispatch(agentlogoRequest());

// 			const { data } = await axiosInstance.post(
// 				'agent/editlogo',
// 				bodyData,
// 				config
// 			);
// 			console.log(data);
// 			// dispatch(agentlogoSuccess(data));
// 			let logodata = {
// 				agent_id: id,
// 			};
// 			dispatch(agentlogogetDispatch(logodata));
// 			if (data.status === 200) {
// 				dispatch(toggleSuccessModal(true));

// 				// storeData('userInfo', data);
// 				setTimeout(() => {
// 					dispatch(toggleSuccessModal(false));

// 					dispatch(setSuccessMessage(''));
// 					dispatch(toggleChangeLogoModal(false));
// 				}, 1200);
// 				dispatch(setSuccessMessage('File Upload Successfully'));
// 			} else {
// 				dispatch(toggleChangeLogoModal(false));
// 				dispatch(toggleErrorModal(true));
// 				dispatch(setErrorMessage(data.result.message));
// 				// history.push('/dashboard');
// 			}
// 		} catch (error) {
// 			dispatch(toggleErrorModal(true));
// 			dispatch(toggleChangeLogoModal(false));
// 			dispatch(
// 				setErrorMessage(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 			dispatch(
// 				agentlogoFail(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 		}
// 	};
// export const agentlogogetDispatch = (bodyData, history) => async (dispatch) => {
// 	try {
// 		dispatch(agentlogogetRequest());

// 		const { data } = await axiosInstance.post('agent/logo', bodyData, config);
// 		// console.log(data);
// 		dispatch(agentlogogetSuccess(data));
// 		storeData('agentlogoget', data);
// 		// if (data.status === 200) {
// 		// 	dispatch(toggleSuccessModal(true));
// 		// 	// storeData('userInfo', data);
// 		// 	setTimeout(() => {
// 		// 		dispatch(toggleSuccessModal(false));

// 		// 		dispatch(setSuccessMessage(''));
// 		// 		dispatch(toggleChangeLogoModal(false));
// 		// 	}, 1200);
// 		// 	dispatch(setSuccessMessage('File Upload Successfully'));
// 		// } else {
// 		// 	dispatch(toggleChangeLogoModal(false));
// 		// 	dispatch(toggleErrorModal(true));
// 		// 	dispatch(setErrorMessage(data.result.message));
// 		// 	// history.push('/dashboard');
// 		// }
// 	} catch (error) {
// 		dispatch(toggleErrorModal(true));
// 		// dispatch(toggleChangeLogoModal(false));
// 		dispatch(
// 			setErrorMessage(
// 				error.response && error.response.data.message
// 					? error.response.data.message
// 					: error.message
// 			)
// 		);
// 		dispatch(
// 			agentlogogetFail(
// 				error.response && error.response.data.message
// 					? error.response.data.message
// 					: error.message
// 			)
// 		);
// 	}
// };
export const agentchangePasswordDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(agentchangepasswordRequest());
		const { data } = await axiosInstance.post(
			'agent/resetpassword',
			bodyData,
			config
		);
		console.log(data);
		dispatch(agentchangepasswordSuccess(data));
		if (data.status === 200) {
		} else {
		}
	} catch (error) {
		dispatch(
			agentchangepasswordFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
// export const agentedituserDispatch =
// 	(bodyData, history) => async (dispatch) => {
// 		try {
// 			dispatch(agentedituserRequest());

// 			const { data } = await axiosInstance.post(
// 				'agent/edituser',
// 				bodyData,
// 				config
// 			);
// 			// console.log(data);
// 			dispatch(agentedituserSuccess(data));
// 			if (data.status === 200) {
// 				dispatch(toggleSuccessModal(true));
// 				// storeData('userInfo', data);
// 				setTimeout(() => {
// 					dispatch(toggleSuccessModal(false));

// 					dispatch(setSuccessMessage(''));
// 					history.push('/dashboard');
// 				}, 1200);
// 				dispatch(setSuccessMessage(data.result.message));
// 			} else {
// 				dispatch(toggleErrorModal(true));
// 				dispatch(setErrorMessage(data.result.message));
// 				// history.push('/dashboard');
// 			}
// 		} catch (error) {
// 			dispatch(toggleErrorModal(true));
// 			dispatch(
// 				setErrorMessage(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 			dispatch(
// 				agentedituserFail(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 		}
// 	};
export const agentbookinghistoryDispatch = (userId) => async (dispatch) => {
	try {
		dispatch(agentbookinghistoryRequest());
		let formData = {
			userId: userId,
		};

		const { data } = await axiosInstance.post(
			'agent/bookinghistory',
			formData,
			config
		);
		dispatch(agentbookinghistorySuccess(data));
	} catch (error) {
		dispatch(
			agentbookinghistoryFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};

export const agenttransactionhistoryDispatch = (userId) => async (dispatch) => {
	try {
		dispatch(agenttransRequest());
		let formData = {
			agent_id: userId,
		};

		const { data } = await axiosInstance.post(
			'agent/agenttrans',
			formData,
			config
		);
		dispatch(agenttransSuccess(data));
	} catch (error) {
		dispatch(
			agenttransFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
// export const agentMarkupDispatch = (userId) => async (dispatch) => {
// 	try {
// 		dispatch(markupRequest());
// 		let formData = {
// 			// userId: userId,
// 			userId: userId,
// 		};

// 		const { data } = await axiosInstance.post(
// 			'agent/agentmarkup',
// 			formData,
// 			config
// 		);
// 		// console.log(data);
// 		dispatch(markupSuccess(data));
// 		storeData('agentMarkup', data);
// 	} catch (error) {
// 		dispatch(toggleErrorModal(true));
// 		dispatch(
// 			setErrorMessage(
// 				error.response && error.response.data.message
// 					? error.response.data.message
// 					: error.message
// 			)
// 		);
// 		dispatch(
// 			markupFail(
// 				error.response && error.response.data.message
// 					? error.response.data.message
// 					: error.message
// 			)
// 		);
// 	}
// };
// export const agentEditMarkupDispatch =
// 	(bodyData, history, id) => async (dispatch) => {
// 		try {
// 			dispatch(markupEditRequest());

// 			const { data } = await axiosInstance.post(
// 				'agent/agenteditmarkup',
// 				bodyData,
// 				config
// 			);
// 			// console.log(data);
// 			dispatch(markupEditSuccess(data));
// 			dispatch(agentMarkupDispatch(id));
// 			if (data.status === 200) {
// 				dispatch(toggleSuccessModal(true));

// 				setTimeout(() => {
// 					dispatch(toggleSuccessModal(false));

// 					dispatch(setSuccessMessage(''));
// 					history.push('/dashboard');
// 				}, 1200);
// 			} else {
// 				dispatch(toggleErrorModal(true));
// 				dispatch(setErrorMessage(data.result.message));
// 			}
// 		} catch (error) {
// 			dispatch(toggleErrorModal(true));
// 			dispatch(
// 				setErrorMessage(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 			dispatch(
// 				markupEditFail(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 		}
// 	};
export const walletBalanceAgentDispatch =
	(userEmail, userId) => async (dispatch) => {
		try {
			dispatch(walletagentRequest());
			let formData = {
				userEmail: userEmail,
				userId: userId,
			};

			const { data } = await axiosInstance.post(
				'agent/walletbalance',
				formData,
				config
			);
			dispatch(walletagentSuccess(data));
		} catch (error) {
			dispatch(
				walletagentFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};
// export const travellerSignupDispatch =
// 	(bodyData, history) => async (dispatch) => {
// 		try {
// 			dispatch(travellersignupRequest());

// 			const { data } = await axiosInstance.post(
// 				'home/registeruser',
// 				bodyData,
// 				config
// 			);
// 			// console.log(data);
// 			dispatch(travellersignupSuccess(data));
// 			if (data.status === 200) {
// 				dispatch(toggleSuccessModal(true));
// 				setTimeout(() => {
// 					dispatch(toggleSuccessModal(false));
// 					// history.push('/agent');
// 					dispatch(toggleRegisterTravellerModal(false));
// 					dispatch(setSuccessMessage(''));
// 				}, 1200);
// 				dispatch(setSuccessMessage(data.result.message));
// 			} else {
// 				dispatch(toggleErrorModal(true));
// 				dispatch(setErrorMessage(data.result.message));
// 				dispatch(toggleRegisterTravellerModal(false));
// 			}
// 		} catch (error) {
// 			dispatch(toggleErrorModal(true));
// 			dispatch(toggleRegisterTravellerModal(false));
// 			dispatch(
// 				setErrorMessage(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 			dispatch(
// 				travellersignupFail(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 		}
// 	};
// export const travellerloginDispatch =
// 	(bodyData, history) => async (dispatch) => {
// 		try {
// 			dispatch(travellerloginRequest());

// 			const { data } = await axiosInstance.post('home/login', bodyData, config);
// 			// console.log(data);
// 			dispatch(travellerloginSuccess(data));

// 			storeData('userInfo', data);
// 			if (data.status === 200) {
// 				dispatch(toggleSuccessModal(true));
// 				dispatch(
// 					walletBalanceDispatch(
// 						data &&
// 							data.result &&
// 							data.result.result &&
// 							data.result.result.email,
// 						data && data.result && data.result.result && data.result.result.id
// 					)
// 				);
// 				dispatch(
// 					travellerbookinghistoryDispatch(
// 						data && data.result && data.result.result && data.result.result.id
// 					)
// 				);
// 				// storeData('userInfo', data);
// 				setTimeout(() => {
// 					dispatch(toggleSuccessModal(false));

// 					dispatch(setSuccessMessage(''));
// 					history.push('/dashboard');
// 				}, 1200);
// 				dispatch(setSuccessMessage('Login Successfully'));
// 			} else {
// 				dispatch(toggleErrorModal(true));
// 				dispatch(setErrorMessage(data.result.message));
// 			}
// 		} catch (error) {
// 			dispatch(toggleErrorModal(true));
// 			dispatch(
// 				setErrorMessage(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 			dispatch(
// 				travellerloginFail(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 		}
// 	};

// export const walletBalanceDispatch =
// 	(userEmail, userId) => async (dispatch) => {
// 		try {
// 			dispatch(walletRequest());
// 			let formData = {
// 				userEmail: userEmail,
// 				userId: userId,
// 			};

// 			const { data } = await axiosInstance.post(
// 				'home/walletbalance',
// 				formData,
// 				config
// 			);
// 			console.log(data);
// 			dispatch(walletSuccess(data));
// 			storeData('walletbalance', data);
// 			// if (data.status === 200) {
// 			// 	dispatch(toggleSuccessModal(true));
// 			// 	storeData('userInfo', data);
// 			// 	setTimeout(() => {
// 			// 		dispatch(toggleSuccessModal(false));
// 			// 		history.push('/dashboard');
// 			// 		dispatch(setSuccessMessage(''));
// 			// 	}, 1200);
// 			// 	// dispatch(setSuccessMessage(data.result.message));
// 			// } else {
// 			// 	dispatch(toggleErrorModal(true));
// 			// 	dispatch(setErrorMessage(data.result.message));
// 			// }
// 		} catch (error) {
// 			dispatch(toggleErrorModal(true));
// 			dispatch(
// 				setErrorMessage(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 			dispatch(
// 				walletFail(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 		}
// 	};
// export const travellerchangePasswordDispatch =
// 	(bodyData, history) => async (dispatch) => {
// 		try {
// 			dispatch(travellerchangepasswordRequest());

// 			const { data } = await axiosInstance.post(
// 				'home/resetpassword',
// 				bodyData,
// 				config
// 			);
// 			// console.log(data);
// 			dispatch(travellerchangepasswordSuccess(data));
// 			if (data.status === 200) {
// 				dispatch(toggleSuccessModal(true));
// 				// storeData('userInfo', data);
// 				setTimeout(() => {
// 					dispatch(toggleSuccessModal(false));

// 					dispatch(setSuccessMessage(''));
// 					history.push('/dashboard');
// 				}, 1200);
// 				dispatch(setSuccessMessage(data.result.message));
// 			} else {
// 				dispatch(toggleErrorModal(true));
// 				dispatch(setErrorMessage(data.result.message));
// 				// history.push('/dashboard');
// 			}
// 		} catch (error) {
// 			dispatch(toggleErrorModal(true));
// 			dispatch(
// 				setErrorMessage(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 			dispatch(
// 				travellerchangepasswordFail(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 		}
// 	};
// export const travelleredituserDispatch =
// 	(bodyData, history) => async (dispatch) => {
// 		try {
// 			dispatch(travelleredituserRequest());

// 			const { data } = await axiosInstance.post(
// 				'home/edituser',
// 				bodyData,
// 				config
// 			);
// 			// console.log(data);
// 			dispatch(travelleredituserSuccess(data));
// 			if (data.status === 200) {
// 				dispatch(toggleSuccessModal(true));
// 				// storeData('userInfo', data);
// 				setTimeout(() => {
// 					dispatch(toggleSuccessModal(false));

// 					dispatch(setSuccessMessage(''));
// 					history.push('/dashboard');
// 				}, 1200);
// 				dispatch(setSuccessMessage(data.result.message));
// 			} else {
// 				dispatch(toggleErrorModal(true));
// 				dispatch(setErrorMessage(data.result.message));
// 				// history.push('/dashboard');
// 			}
// 		} catch (error) {
// 			dispatch(toggleErrorModal(true));
// 			dispatch(
// 				setErrorMessage(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 			dispatch(
// 				travelleredituserFail(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 		}
// 	};
// export const travellerbookinghistoryDispatch = (userId) => async (dispatch) => {
// 	try {
// 		dispatch(travellerbookinghistoryRequest());
// 		dispatch(agentbookinghistorySuccess(null));
// 		let formData = {
// 			// userId: userId,
// 			userId: 1,
// 		};

// 		const { data } = await axiosInstance.post(
// 			'agent/bookinghistory',
// 			formData,
// 			config
// 		);
// 		// console.log(data);
// 		dispatch(travellerbookinghistorySuccess(data));
// 		storeData('bookinghistory', data);
// 		// if (data.status === 200) {
// 		// 	dispatch(toggleSuccessModal(true));
// 		// 	// storeData('userInfo', data);
// 		// 	setTimeout(() => {
// 		// 		dispatch(toggleSuccessModal(false));
// 		// 		history.push('/dashboard');
// 		// 		dispatch(setSuccessMessage(''));
// 		// 	}, 1200);
// 		// 	// dispatch(setSuccessMessage(data.result.message));
// 		// } else {
// 		// 	dispatch(toggleErrorModal(true));
// 		// 	dispatch(setErrorMessage(data.result.message));
// 		// }
// 	} catch (error) {
// 		dispatch(toggleErrorModal(true));
// 		dispatch(
// 			setErrorMessage(
// 				error.response && error.response.data.message
// 					? error.response.data.message
// 					: error.message
// 			)
// 		);
// 		dispatch(
// 			travellerbookinghistoryFail(
// 				error.response && error.response.data.message
// 					? error.response.data.message
// 					: error.message
// 			)
// 		);
// 	}
// };
// export const verifyAccountDispatch =
// 	(formData, history) => async (dispatch) => {
// 		try {
// 			dispatch(verifyRequest());

// 			const { data } = await axiosInstance.post(
// 				'home/verify',
// 				formData,
// 				config
// 			);
// 			console.log(data);
// 			dispatch(verifySuccess(data));
// 			if (data.status === 200) {
// 				setTimeout(() => {
// 					history.push('/');
// 				}, [5000]);
// 			} else {
// 				setTimeout(() => {
// 					history.push('/');
// 				}, [7000]);
// 			}
// 		} catch (error) {
// 			// dispatch(toggleErrorModal(true));

// 			dispatch(
// 				setErrorMessage(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 			dispatch(
// 				verifyFail(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 		}
// 	};

// export const flightTicketDispatch = (formData, history) => async (dispatch) => {
// 	try {
// 		dispatch(flightTicketRequest());

// 		const { data } = await axiosInstance.post(
// 			'flight/flightticket',
// 			formData,
// 			config
// 		);
// 		// console.log(data);
// 		dispatch(flightTicketSuccess(data));
// 	} catch (error) {
// 		dispatch(
// 			setErrorMessage(
// 				error.response && error.response.data.message
// 					? error.response.data.message
// 					: error.message
// 			)
// 		);
// 		dispatch(
// 			flightTicketFail(
// 				error.response && error.response.data.message
// 					? error.response.data.message
// 					: error.message
// 			)
// 		);
// 	}
// };

// export const forgotPasswordDispatch =
// 	(formData, actions, setValue) => async (dispatch) => {
// 		try {
// 			dispatch(forgotPasswordRequest());

// 			const { data } = await axiosInstance.post(
// 				'agent/forgotpassword',
// 				formData,
// 				config
// 			);
// 			// console.log(data);
// 			actions.setSubmitting(false);

// 			dispatch(forgotPasswordSuccess(data));
// 			if (data.status === 200) {
// 				dispatch(toggleSuccessModal(true));
// 				dispatch(
// 					setSuccessMessage(`${data.result.message} Please Check Your Email`)
// 				);
// 				setTimeout(() => {
// 					dispatch(toggleSuccessModal(false));
// 					setValue(0);
// 				}, [2000]);
// 			} else {
// 				dispatch(toggleErrorModal(true));
// 				dispatch(setErrorMessage(data.result.message));
// 			}
// 		} catch (error) {
// 			dispatch(toggleErrorModal(true));
// 			dispatch(
// 				setErrorMessage(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 			dispatch(
// 				forgotPasswordFail(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 		}
// 	};

// export const forgotPasswordTravellerDispatch =
// 	(formData, history) => async (dispatch) => {
// 		try {
// 			dispatch(forgotPasswordTravellerRequest());

// 			const { data } = await axiosInstance.post(
// 				'home/forgotpassword',
// 				formData,
// 				config
// 			);
// 			// console.log(data);
// 			dispatch(forgotPasswordTravellerSuccess(data));
// 			if (data.status === 200) {
// 				dispatch(toggleSuccessModal(true));

// 				dispatch(
// 					setSuccessMessage(`${data.result.message} Please Check Your Email`)
// 				);
// 				setTimeout(() => {
// 					dispatch(toggleSuccessModal(false));
// 				}, [2000]);
// 			} else {
// 				dispatch(toggleErrorModal(true));
// 				dispatch(setErrorMessage(data.result.message));
// 			}
// 		} catch (error) {
// 			dispatch(toggleErrorModal(true));
// 			dispatch(
// 				setErrorMessage(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 			dispatch(
// 				forgotPasswordTravellerFail(
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message
// 				)
// 			);
// 		}
// 	};
export default UserReducer;
